import { USERS_LOAD_REQUEST, USERS_LOAD_SUCCESS, USERS_LOAD_FAILURE } from '../types/users-types';
import { ADD_REPORT_TO_USER, REMOVE_REPORT_FROM_USER } from '../types/user-types';
import { TReport } from '../../../../reports/definitions';

const initialState = {
  loading: false,
  error: null,
  success: false,
  users: []
};

const addReportToUser = (report: TReport, users: unknown[], user_ids: string[]) => {
  return users.map((user) => {
    // @ts-ignore
    if (user_ids.includes(user.id)) {
      if (user) {
        // @ts-ignore
        return {
          // @ts-ignore
          ...user,
          permissions: {
            ...user.permissions,
            reports: [...user.permissions.reports, report]
          }
        };
      }
    }
    return user;
  });
};

const removeReportFromUser = (report: TReport, users: unknown[], user_ids: string[]) => {
  return users.map((user) => {
    // @ts-ignore
    if (user_ids.includes(user.id)) {
      if (user) {
        // @ts-ignore
        return {
          // @ts-ignore
          ...user,
          permissions: {
            ...user.permissions,
            reports: user.permissions.reports.filter((r: TReport) => r.id !== report.id)
          }
        };
      }
    }
    return user;
  });
};

function users(state = initialState, action: any = null) {
  switch (action.type) {
    case USERS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case USERS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case USERS_LOAD_SUCCESS:
      return {
        ...state,
        users: action.payload,
        success: true,
        loading: false,
        error: null
      };

    case ADD_REPORT_TO_USER:
      return {
        ...state,
        users: addReportToUser(action.payload.report, state.users, action.payload.user_ids)
      };

    case REMOVE_REPORT_FROM_USER:
      return {
        ...state,
        users: removeReportFromUser(action.payload.report, state.users, action.payload.user_ids)
      };
    default:
      return state;
  }
}

export default users;
